import { useOrderStatus } from '@/data/Content/HdmOrderDeliveryDetails';
import { useLocalization } from '@/data/Localization';

import { TextLine } from './TextLine';

export const RecentOrdersDeliveryDate = ({ orderId }: { orderId: string }) => {
	const HeaderMyRecentOrdersLabels = useLocalization('HeaderMyRecentOrderPanel');

	const { orderDeliveryDetails, error } = useOrderStatus(orderId, {
		responseFormat: 'json',
		orderDetailsPage: true,
		itemDeliveryType: 'Fleet',
	});

	if (error) return null;
	const date = orderDeliveryDetails?.fmtDeliveryRanges![0]?.replaceAll('/', '') || '';

	return (
		<TextLine
			orderInfoLabel={HeaderMyRecentOrdersLabels.DeliveringDate.t()}
			orderValueLabel={date}
		/>
	);
};
